module.exports = __webpack_public_path__ + "static/media/emailVerifySuccess.10b2526b.svg";